import React, { useState, useEffect, Fragment } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Add, Create, Money } from '@material-ui/icons';

import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import Button from 'components/CustomButtons/Button.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll } from 'services/WService.js';
import { WithApp } from 'contexts/appContext';
import { useModal } from 'hooks/useModal';
import Modal from './Modal';
import { Toasty, useToasty } from 'hooks/Toasty';
import { Link } from 'react-router-dom';
import Visibility from '@material-ui/icons/Visibility';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  },
  size: {
    fontSize: '4.4rem'
  }
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Número', accessor: 'number' },
  { Header: 'Nombre de lista', accessor: 'name' },
  { Header: 'Número base', accessor: 'baseNum' },
  { Header: 'Factor', accessor: 'factor' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function PriceList(props) {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();

  const [priceLists, setPriceLists] = useState([]);
  const [model, setOpen] = useModal();
  const [dataLoading, setDataLoading] = useState(false);

  async function getPriceList() {
    setDataLoading(true);
    let response = await wsGetAll('logi/price-list');
    setDataLoading(false);
    if (response.success) setPriceLists(response.data);
  }

  useEffect(() => {
    getPriceList();
  }, []);

  return (
    <Fragment>
      <Toasty action={notify} />
      <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={getPriceList} />
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader icon>
              <AllowedGuard
                permission={ConstantPermissions.LOGI_PRICE_LISTS_STORE}
                component={
                  <CardIcon color="primary">
                    <Money style={{ color: 'white' }} />
                  </CardIcon>
                }
              >
                <CardIcon
                  onClick={() => setOpen({})}
                  pointer="true"
                  color={props.themeContext.buttonColorSuccess}
                >
                  <Add />
                </CardIcon>
              </AllowedGuard>
              <h4 className={classes.cardIconTitle}>Listas de Precios {dataLoading && <LoadingSpinner />}</h4>
            </CardHeader>
            <CardBody>
              <ReactTable
                excelName="Precios"
                defaultWidth={1000}
                indexRow={[0, 1, 3, 4, 5]}
                widthRow={[120, 100, 350, 120, 5]}
                columns={columns}
                data={priceLists.map((priceList, i) => {
                  return {
                    num: (
                      <div className="actions-right">
                        {i + 1}
                        <AllowedGuard permission={ConstantPermissions.LOGI_PRICE_LISTS_SHOW}>
                          <Button justIcon round simple color="info" className="like">
                            <Link to={`${priceList.id}`}>
                              <Visibility />
                            </Link>
                          </Button>
                        </AllowedGuard>
                        <AllowedGuard permission={ConstantPermissions.LOGI_PRICE_LISTS_UPDATE}>
                          <Button
                            justIcon
                            round
                            simple
                            color={props.themeContext.buttonColorWarning}
                            onClick={() => {
                              setOpen(priceList);
                            }}
                          >
                            <Create />
                          </Button>
                        </AllowedGuard>
                      </div>
                    ),
                    number: priceList.ListNum,
                    name: priceList.ListName,
                    baseNum: priceList.BASE_NUM,
                    factor: parseFloat(priceList.Factor).toFixed(2),
                    actions: ''
                  };
                })}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </Fragment>
  );
});
